<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative title-bar">
    <div class="vx-navbar-wrapper" :class="classObj">
      <div class="bartop">
        <div class="logo">
          <img src="@/assets/images/pages/tacna-logo.svg" alt="" />
        </div>
      </div>
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <!-- <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" /> -->
        <vs-spacer />
        <!-- <i18n /> -->
        <div class="mr-2"></div>

        <!-- <notification-drop-down /> -->
        <div class="mr-2"></div>
        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>

<script>
//import Bookmarks            from './components/Bookmarks.vue'
//import I18n                   from './components/I18n.vue'
//import SearchBar            from './components/SearchBar.vue'
//import CartDropDown         from   './components/CartDropDown.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown from './components/ProfileDropDown.vue'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff',
    },
  },
  components: {
    //Bookmarks,
    //I18n,
    //SearchBar,
    //CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff'
        ? '#10163a'
        : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor() {
      return {
        'text-white':
          (this.navbarColor !== '#10163a' &&
            this.$store.state.theme === 'dark') ||
          (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark'),
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth) return 'navbar-full'
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },
  },
}
</script>

<style lang="scss">
.bartop {
  position: absolute;
  width: 100%;
  height: 60px;
  left: 0px;
  top: 0px;
  filter: drop-shadow(0px 4px 11px rgba(0, 0, 0, 0.14));
  background: #ffffff;
}
.logo {
  text-align: center;
  margin-top: 12px;
}
.logo > img {
  width: 127px;
}
</style>
